import {
  Button,
  IconName,
  InputGroupProps,
  InputGroup,
  Intent,
  MaybeElement,
} from "@blueprintjs/core"
import React, { useEffect, useState } from "react"
import useDoneTyping from "hooks/useDoneTyping"

interface QueryBarProps extends Omit<InputGroupProps, "onChange"> {
  id?: any
  onSubmit?: ((event: React.FormEvent<HTMLFormElement>) => void) | undefined
  rightIcon?: IconName | MaybeElement
  width?: number | string
  onChange?: (query: string) => void
  onBlur?: any
  onFocus?: any
}
const QueryBar = ({
  onSubmit,
  id,
  placeholder,
  onChange,
  rightIcon,
  width,
  className,
  round,
  leftIcon,
  value,
  onBlur,
  onFocus,
}: QueryBarProps) => {
  const [query, setQuery] = useState<string | undefined>("")

  useEffect(() => {
    setQuery(value)
  }, [value, setQuery])
  const inputFunctions = useDoneTyping({
    doneTyping() {
      onChange && onChange(query)
    },
  })
  function handleSubmit(e: any) {
    e.preventDefault()
    if (onSubmit) onSubmit(e.target?.[0]?.value)
  }
  function handleChange(e: any) {
    e.preventDefault()
    setQuery(e.target.value)
  }

  return (
    <form style={{ width }} className={className} onSubmit={handleSubmit}>
      <InputGroup
        id={id}
        round={round}
        placeholder={placeholder}
        width={width}
        leftIcon={leftIcon}
        onChange={onChange ? handleChange : undefined}
        onBlur={onBlur}
        onFocus={onFocus}
        value={query ?? ""}
        rightElement={
          <Button
            onClick={(e: any) => {
              setQuery("")
              onChange("")
            }}
            type="submit"
            icon={rightIcon}
            minimal={true}
            intent={Intent.PRIMARY}
          />
        }
        {...inputFunctions}
      />
    </form>
  )
}

QueryBar.defaultProps = {
  placeholder: "Search...",
  rightIcon: "cross",
  leftIcon: "search",
  round: true,
  width: 360,
  onChange: null,
}
export default QueryBar
